import { render } from "./PollAnswer.vue?vue&type=template&id=3b8563e7"
import script from "./PollAnswer.vue?vue&type=script&lang=js"
export * from "./PollAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__